import getters from './getters';
import actions from './actions';
import mutations from './mutations'
const state = {
   job : {
    description: '',
   },
   jobs : []
}

const job = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default job;